import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
/**
 * Generated class for the HomeDashboardAlertsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-alerts',
  templateUrl: 'home-dashboard-alerts.html',
})
export class HomeDashboardAlertsPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public translate: TranslateService) {
  }


  openCloseCashBlog() {
    var blog_url = 'https://www.mycheftool.com/post/nuevo-cierre-de-caja';
    if (this.globals.so_mobile) {
      window.location.assign(blog_url);
    } else {
      window.open(blog_url, '_blank');
    }
  }



}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-alerts/home-dashboard-alerts.ts